module.exports = __webpack_public_path__ + "static/media/speed_squad.0313a831.gif";


//////////////////
// WEBPACK FOOTER
// ./src/modules/wechatShare/components/images/speed_squad.gif
// module id = 892
// module chunks = 0